
import { message, Select, Space } from 'antd';
import styles from './index.module.scss'
import { RESOURCE_TYPE, IMAGE_TYPE } from '@utils/CONST'
import { useContext, useEffect, useState } from 'react'
import { GenerateContext } from '../../../hooks/GenerateContext'
import API from '@api/api'
import SelectionFilterSearch from '../SelectionFilterSearch'

const SelectionFilter = (props) => {
    const {
        resourceFilter, setResourceFilter
    } = useContext(GenerateContext)
    const { resourceType } = props
    const [clothesCateOpts, setClothesCateOpts] = useState([])
    const [shoesTypeOpts, setShoesTypeOpts] = useState([])
    const [shoesposeOpts, setShoesPoseOpts] = useState([])
    const [viewOpts, setViewOpts] = useState([])
    const [commodityTypeCategory, setCommodityTypeCategory] = useState([]) // 商品类别
    const [sceneTypeCategory, setSceneTypeCategory] = useState([]) // 场景类别
    const [flatlayCategoryOpts, setFlatlayCategoryOpts] = useState([])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.TRYON_MODEL) return
        API.categoryList({
            category: 'clothesCate',
            resourceType: 'tryon',
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            const list = res.data.map(item => ({ label: item.display, value: item.value }))
            setClothesCateOpts(list || [])
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.POSE_TRYON) return
        API.categoryList({
            category: 'view',
            resourceType: 'posefantasy',
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            const list = res.data.map(item => ({ label: item.display, value: item.value }))
            setViewOpts(list || [])
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.TRYON_SHOES) return
        Promise.all([
            API.categoryList({
                category: 'shoesType',
                resourceType: 'shoestryon',
            }),
            API.categoryList({
                category: 'poseType',
                resourceType: 'shoestryon',
            })
        ]).then(resList => {
            for (let i = 0; i < resList.length; i++) {
                const res = resList[i]
                if (res.code != 0) throw new Error(res.message)
                let shoesList = res.data.map(item => ({ label: item.display, value: item.value }))
                if (i == 0) {
                    setShoesTypeOpts(shoesList)
                } else if (i == 1) {
                    setShoesPoseOpts(shoesList)
                }
            }
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    const [skinsOpts, setSkinsOpts] = useState([])
    const [clothStylesOpts, setClothStylesOpts] = useState([])
    const [clothPatternsOpts, setClothPatternsOpts] = useState([])
    const [clothTypesOpts, setClothTypesOpts] = useState([])
    const [modelSceneTypeOpts, setModelSceneTypeOpts] = useState([])
    const [modelCompositionTypeOpts, setModelCompositionTypeOpts] = useState([])
    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.SIM_TRYON) return
        Promise.all([
            API.categoryList({
                category: 'skin',
                resourceType: 'simtryon',
            }),
            API.categoryList({
                category: 'clothStyles',
                resourceType: 'simtryon',
            }),
            API.categoryList({
                category: 'clothPatterns',
                resourceType: 'simtryon',
            }),
            API.categoryList({
                category: 'clothTypes',
                resourceType: 'simtryon',
            })
        ]).then(([res1, res2, res3, res4]) => {
            const skinsOpts = res1.data
            const clothStylesOpts = res2.data
            const clothPatternsOpts = res3.data
            const clothTypesOpts = res4.data
            setSkinsOpts(skinsOpts || [])
            setClothStylesOpts(clothStylesOpts || [])
            setClothPatternsOpts(clothPatternsOpts || [])
            setClothTypesOpts(clothTypesOpts || [])
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.COMMODITY_SCENE) return
        Promise.all([
            API.bgCategoryList({ type: IMAGE_TYPE.COMMODITY, category: 'sceneType' }),
            API.bgCategoryList({ type: IMAGE_TYPE.COMMODITY, category: 'commodityType' }),
        ]).then(res => {
            const res1 = res[0]
            const res2 = res[1]
            if (res1.code != 0) throw new Error(res1.message)
            if (res2.code != 0) throw new Error(res2.message)
            setSceneTypeCategory([...res1.data.map(item => ({
                label: item.display,
                value: item.value
            }))])
            setCommodityTypeCategory([...res2.data.map(item => ({
                label: item.display,
                value: item.value
            }))])
        }).catch(err => {
            message.warning(err.message)
        })
    }, [resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.FLATLAY3D) return
        API.categoryList({
            resourceType: 'model',
            func: 'flat',
            localField: 'categoryTags',
            category: 'categoryTags',
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            const list = (res.data || []).map(item => ({
                label: item.display,
                value: item.value,
            }))
            setFlatlayCategoryOpts(list)
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.MODEL_SCENE && resourceType != RESOURCE_TYPE.TRYON_SCENE) return
        Promise.all([
            API.categoryList({
                func: 'background',
                category: 'sceneTags',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'background',
                category: 'compositionTags',
                resourceType: 'model',
            })
        ]).then(([res1, res2]) => {
            const modelSceneTypeOpts = res1.data.map((item) => {
                return {
                    label: item.display,
                    title: item.display,
                    options: item.subList.map(opt => ({
                        label: opt.display,
                        value: item.display + '/' + opt.value,
                    })),
                }
            })
            const modelCompositionTypeOpts = res2.data
            setModelSceneTypeOpts(modelSceneTypeOpts || [])
            setModelCompositionTypeOpts(modelCompositionTypeOpts || [])
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    const [sexTagOpts, setSexTagOpts] = useState([])
    const [ageTagsOpts, setAgeTagsOpts] = useState([])
    const [skinTagsOpts, setSkinTagsOpts] = useState([])
    const [toneTagsOpts, setToneTagsOpts] = useState([])
    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.MODEL) {
            setSexTagOpts(sexOpts)
            setAgeTagsOpts(ageOpts)
            setSkinTagsOpts(skinOpts)
            return
        }
        Promise.all([
            API.categoryList({
                func: 'person',
                category: 'sexTag',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'person',
                category: 'ageTags',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'person',
                category: 'skinTags',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'person',
                category: 'toneTags',
                resourceType: 'model',
            })
        ]).then(([res1, res2, res3, res4]) => {
            setSexTagOpts(res1.data || [])
            setAgeTagsOpts(res2.data || [])
            setSkinTagsOpts(res3.data || [])
            setToneTagsOpts(res4.data || [])
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    const sexOpts = [{
        value: 'female',
        label: '女',
    }, {
        value: 'male',
        label: '男',
    }]
    const sexOpts2 = [{
        value: '女',
        label: '女',
    }, {
        value: '男',
        label: '男',
    }]
    const ageOpts = [{
        value: 'adult',
        label: '成年',
    }, {
        value: 'children',
        label: '儿童',
    }]
    const ageOpts2 = [{
        value: '成年',
        label: '成年',
    }, {
        value: '儿童',
        label: '儿童',
    }]
    const skinOpts = [{
        label: '黄',
        value: 'yellow',
    }, {
        label: '白',
        value: 'white',
    }, {
        label: '黑',
        value: 'black',
    }]
    const optFactory = (opt, placeholder, mode = "multiple") => {
        return {
            className: styles.ModelFilterSelect,
            mode: mode,
            allowClear: true,
            showSearch: false,
            style: { width: "100px", height: "32px" },
            size: 'small',
            maxTagCount: 'responsive',
            placeholder: placeholder,
            options: opt
        }
    }
    const handleChange = (key, value) => {
        if (Array.isArray(value)) {
            setResourceFilter(pre => ({ ...pre, [key]: [...value] }))
        } else {
            setResourceFilter(pre => ({ ...pre, [key]: value }))
        }
    }

    useEffect(() => {
        console.log('resourceFilter', resourceFilter)
    }, [resourceFilter])

    const tagRender = (props) => {
        const { label } = props;
        return <span className={styles.ModelFilterSelect_tag}>{label}</span>
    }
    const sexTagSelect = (
        <Select
            {...optFactory(sexTagOpts, '性别')}
            value={resourceFilter.sex}
            onChange={v => handleChange('sex', v)}
            tagRender={tagRender}
        />
    )
    const modelSexTagSelect = (
        <Select
            {...optFactory(sexTagOpts, '性别')}
            value={resourceFilter.model_sex}
            onChange={v => handleChange('model_sex', v)}
            tagRender={tagRender}
        />
    )
    const ageTagSelect = (
        <Select
            {...optFactory(ageTagsOpts, '年龄')}
            value={resourceFilter.age}
            onChange={v => handleChange('age', v)}
            tagRender={tagRender}
        />
    )
    const modelAgeTagSelect = (
        <Select
            {...optFactory(ageTagsOpts, '年龄')}
            value={resourceFilter.model_age}
            onChange={v => handleChange('model_age', v)}
            tagRender={tagRender}
        />
    )
    const skinTagSelect = (
        <Select
            {...optFactory(skinTagsOpts, '肤色')}
            value={resourceFilter.skin}
            onChange={v => handleChange('skin', v)}
            tagRender={tagRender}
        />
    )
    const modelSkinTagSelect = (
        <Select
            {...optFactory(skinTagsOpts, '肤色')}
            value={resourceFilter.model_skin}
            onChange={v => handleChange('model_skin', v)}
            tagRender={tagRender}
        />
    )
    const toneTagSelect = (
        <Select
            {...optFactory(toneTagsOpts, '气质类型')}
            value={resourceFilter.toneTags}
            onChange={v => handleChange('toneTags', v)}
            tagRender={tagRender}
        />
    )
    const sexSelect = (
        <Select
            {...optFactory(sexOpts, '性别')}
            value={resourceFilter.sex}
            onChange={v => handleChange('sex', v)}
            tagRender={tagRender}
        />
    )
    const sexSelect2 = (
        <Select
            {...optFactory(sexOpts2, '性别')}
            value={resourceFilter.sex}
            onChange={v => handleChange('sex', v)}
            tagRender={tagRender}
        />
    )
    const skinSelect = (
        <Select
            {...optFactory(skinOpts, '肤色')}
            value={resourceFilter.skin}
            onChange={v => handleChange('skin', v)}
            tagRender={tagRender}
        />
    )
    const ageSelect = (
        <Select
            {...optFactory(resourceType == RESOURCE_TYPE.POSE_TRYON ? ageOpts2 : ageOpts, '年龄')}
            value={resourceFilter.age}
            onChange={v => handleChange('age', v)}
            tagRender={tagRender}
        />
    )
    const categorySelect = (
        <Select
            {...optFactory(clothesCateOpts, '服饰品类')}
            value={resourceFilter.clothesCate}
            onChange={v => handleChange('clothesCate', v)}
            tagRender={tagRender}
        />
    )
    const shoesType = (
        <Select
            {...optFactory(shoesTypeOpts, '品类')}
            value={resourceFilter.shoesType}
            onChange={v => handleChange('shoesType', v)}
            tagRender={tagRender}
        />
    )
    const shoesPose = (
        <Select
            {...optFactory(shoesposeOpts, '姿势')}
            value={resourceFilter.pose}
            onChange={v => handleChange('pose', v)}
            tagRender={tagRender}
        />
    )
    const commodityType = (
        <Select
            {...optFactory(commodityTypeCategory, '商品类别', null)}
            value={resourceFilter.commodityType}
            onChange={v => handleChange('commodityType', v)}
            tagRender={tagRender}
        />
    )
    const sceneType = (
        <Select
            {...optFactory(sceneTypeCategory, '背景类别', null)}
            value={resourceFilter.sceneType}
            onChange={v => handleChange('sceneType', v)}
            tagRender={tagRender}
        />
    )
    const flatlayCategoryType = (
        <Select
            {...optFactory(flatlayCategoryOpts, '品类')}
            value={resourceFilter.categoryTags}
            onChange={v => handleChange('categoryTags', v)}
            tagRender={tagRender}
        />
    )
    const modelSceneType = (
        <Select
            {...optFactory(modelSceneTypeOpts, '背景类别')}
            value={resourceFilter.sceneTags}
            onChange={v => handleChange('sceneTags', v)}
            tagRender={tagRender}
        />
    )
    const modelCompositionType = (
        <Select
            {...optFactory(modelCompositionTypeOpts, '构图')}
            value={resourceFilter.compositionTags}
            onChange={v => handleChange('compositionTags', v)}
            tagRender={tagRender}
        />
    )
    const viewType = (
        <Select
            {...optFactory(viewOpts, '视角')}
            value={resourceFilter.view}
            onChange={v => handleChange('view', v)}
            tagRender={tagRender}
        />
    )
    const skinSelect2 = (
        <Select
            {...optFactory(skinsOpts, '肤色')}
            value={resourceFilter.skin}
            onChange={v => handleChange('skin', v)}
            tagRender={tagRender}
        />
    )
    const clothStyleSelect = (
        <Select
            {...optFactory(clothStylesOpts, '图片构图')}
            value={resourceFilter.clothStyles}
            onChange={v => handleChange('clothStyles', v)}
            tagRender={tagRender}
        />
    )
    const clothPatternSelect = (
        <Select
            {...optFactory(clothPatternsOpts, '服装分类')}
            value={resourceFilter.clothPatterns}
            onChange={v => handleChange('clothPatterns', v)}
            tagRender={tagRender}
        />
    )
    const clothTypeSelect = (
        <Select
            {...optFactory(clothTypesOpts, '服装类目')}
            value={resourceFilter.clothTypes}
            onChange={v => handleChange('clothTypes', v)}
            tagRender={tagRender}
        />
    )

    if (resourceType == RESOURCE_TYPE.MODEL) {
        return (
            <Space size={12}>
                {modelSexTagSelect}
                {modelAgeTagSelect}
                {modelSkinTagSelect}
                {toneTagSelect}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.TRYON_MODEL) {
        return (
            <Space size={12}>
                {sexTagSelect}
                {ageTagSelect}
                {skinTagSelect}
                {/* {toneTagSelect} */}
                {categorySelect}
                <SelectionFilterSearch onChange={v => handleChange('text', v)} />
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.POSE_TRYON) {
        return (
            <Space size={12}>
                {sexSelect2}
                {ageSelect}
                {viewType}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.SIM_TRYON) {
        return (
            <Space size={12}>
                {clothTypeSelect}
                {clothPatternSelect}
                {clothStyleSelect}
                {skinSelect2}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.TRYON_SHOES) {
        return (
            <Space size={12}>
                {shoesType}
                {shoesPose}
                {sexSelect2}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
        return (
            <Space size={12}>
                {sexSelect}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
        return (
            <Space size={12}>
                {commodityType}
                {sceneType}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.FLATLAY3D) {
        return (
            <Space size={12}>
                {flatlayCategoryType}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.MODEL_SCENE || resourceType == RESOURCE_TYPE.TRYON_SCENE) {
        return (
            <Space size={12}>
                {modelSceneType}
                {modelCompositionType}
                <SelectionFilterSearch onChange={v => handleChange('text', v)} />
            </Space>
        )
    }
}

export default SelectionFilter
